module.exports = __webpack_public_path__ + "static/media/long-arrow-alt-left.2c88cde2.svg";